import { api } from "./client";

export const superadminApi = {
  dashboard: async () => (await api.get("/api/superadmin/dashboard")).data,

  listLocales: async () => (await api.get("/api/superadmin/locales")).data,
  getLocal:    async (id) => (await api.get(`/api/superadmin/locales/${id}`)).data,
  createLocal: async (data) => (await api.post("/api/superadmin/locales", data)).data,
  updateLocal: async (id, data) => (await api.put(`/api/superadmin/locales/${id}`, data)).data,

  listNodos:           async () => (await api.get("/api/superadmin/nodos")).data,
  listNodosDisponibles: async () => (await api.get("/api/superadmin/nodos-disponibles")).data,
  createNodo:          async (data) => (await api.post("/api/superadmin/nodos", data)).data,
  updateNodo:          async (id, data) => (await api.put(`/api/superadmin/nodos/${id}`, data)).data,
  deleteNodo:          async (id) => (await api.delete(`/api/superadmin/nodos/${id}`)).data,
  regenerateToken:     async (id) => (await api.post(`/api/superadmin/nodos/${id}/regenerate-token`)).data,
  wizardNuevoLocal:    async (data) => (await api.post("/api/superadmin/wizard/nuevo-local", data)).data,

  listUsuarios:  async () => (await api.get("/api/superadmin/usuarios")).data,
  createUsuario: async (data) => (await api.post("/api/superadmin/usuarios", data)).data,
  updateUsuario: async (id, data) => (await api.put(`/api/superadmin/usuarios/${id}`, data)).data,
  resetPassword: async (id, password) => (await api.post(`/api/superadmin/usuarios/${id}/password`, { password })).data,
  deleteUsuario: async (id) => (await api.delete(`/api/superadmin/usuarios/${id}`)).data,

  deleteLocal: async (id, force = false) =>
    (await api.delete(`/api/superadmin/locales/${id}${force ? "?force=true" : ""}`)).data,

  audit: async (params = {}) => {
    const qs = new URLSearchParams(
      Object.fromEntries(Object.entries(params).filter(([_, v]) => v !== undefined && v !== ""))
    ).toString();
    return (await api.get(`/api/superadmin/audit${qs ? "?" + qs : ""}`)).data;
  },
};

export const setupApi = {
  needsSeed: async () => (await api.get("/api/setup/needs-seed")).data,
  seed:      async () => (await api.post("/api/setup/seed")).data,
};
